import { render, staticRenderFns } from "./AdminSubcategoryAddModal.vue?vue&type=template&id=5780e606"
import script from "./AdminSubcategoryAddModal.vue?vue&type=script&lang=js"
export * from "./AdminSubcategoryAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5780e606')) {
      api.createRecord('5780e606', component.options)
    } else {
      api.reload('5780e606', component.options)
    }
    module.hot.accept("./AdminSubcategoryAddModal.vue?vue&type=template&id=5780e606", function () {
      api.rerender('5780e606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminSubcategoryAddModal.vue"
export default component.exports